export default {
  Application: {
    ViewListShort: "tam:rbs",
    ViewList: "tam:rb",
    ViewDetail: "tam:r",
    Create: "tam:c",
    Update: "tam:e",
    Active: "tam:ac",
    Inactive: "tam:in",
  },
  Tenant: {
    ViewListShort: "ten:rbs",
    ViewList: "ten:rb",
    ViewDetail: "ten:r",
    Create: "ten:c",
    Update: "ten:e",
    Active: "ten:ac",
    Inactive: "ten:in",
  },
  Organization: {
    ViewListShort: "org:rbs",
    ViewList: "org:rb",
    ViewDetail: "org:r",
    Create: "org:c",
    Update: "org:e",
    Active: "org:ac",
    Inactive: "org:in",
  },
  Partner: {
    ViewListShort: "ptn:rbs",
    ViewList: "ptn:rb",
    ViewDetail: "ptn:r",
    Create: "ptn:c",
    Update: "ptn:e",
    Active: "ptn:ac",
    Inactive: "ptn:in",
  },
  Title: {
    ViewListShort: "otl:rbs",
    ViewList: "otl:rb",
    ViewDetail: "otl:r",
    Create: "otl:c",
    Update: "otl:e",
    Active: "otl:ac",
    Inactive: "otl:in",
  },
  Branch: {
    ViewListShort: "obr:rbs",
    ViewList: "obr:rb",
    ViewDetail: "obr:r",
    Create: "obr:c",
    Update: "obr:e",
    Active: "obr:ac",
    Inactive: "obr:in",
  },
  Employee: {
    ViewListShort: "emp:rbs",
    ViewList: "emp:rb",
    ViewDetail: "emp:r",
    Create: "emp:c",
    Update: "emp:e",
    Import: "emp:im",
    AssignToApp: "emp:tam:cb",
    RemoveToApp: "emp:tam:db",
    Active: "emp:ac",
    Inactive: "emp:in",
  },
  Department: {
    ViewListShort: "dep:rbs",
    ViewList: "dep:rb",
    ViewDetail: "dep:r",
    Create: "dep:c",
    Update: "dep:e",
    Delete: "dep:d",
    Active: "dep:ac",
    Inactive: "dep:in",
    ViewHead: "dep:emp:r",
    ViewListManager: "dep:emp:rb",
  },
  OrgChart: {
    View: "ogc:r",
    ViewListCost: "ogc:dep:rb",
    ShowAllEmployee: "ogc:emp:rb",
    AddNode: "ogc:dep:c",
    UpdateNode: "ogc:dep:e",
    RemoveNode: "ogc:dep:d",
    AddManager: "ogc:emp:c",
    RemoveManager: "ogc:emp:d",
  },
  GroupEmployee: {
    ViewListShort: "gem:rbs",
    ViewList: "gem:rb",
    ViewDetail: "gem:r",
    Create: "gem:c",
    Update: "gem:e",
    Delete: "gem:d",
    Active: "gem:ac",
    Inactive: "gem:in",
    ViewListEmployee: "gem:emp:rb",
    AddEmployee: "gem:emp:cb",
    RemoveEmployee: "gem:emp:db",
    AddRole: "gem:rom:cb",
    RemoveRole: "gem:rom:db",
    ViewListRole: "gem:rom:rb",
  },
  Feature: {
    ViewListShort: "fem:rbs",
    ViewList: "fem:rb",
    ViewDetail: "fem:r",
    Create: "fem:c",
    Update: "fem:e",
    Active: "fem:ac",
    Inactive: "fem:in",
  },
  Role: {
    ViewListShort: "rom:rbs",
    ViewList: "rom:rb",
    ViewDetail: "rom:r",
    Create: "rom:c",
    Update: "rom:e",
    Delete: "rom:d",
    Active: "rom:ac",
    Inactive: "rom:in",
  },
  WorkLevel: {
    ViewListShort: "owl:rbs",
    ViewList: "owl:rb",
    ViewDetail: "owl:r",
    Create: "owl:c",
    Update: "owl:e",
    Active: "owl:ac",
    Inactive: "owl:in",
  },
  ContractType: {
    ViewListShort: "oct:rbs",
    ViewList: "oct:rb",
    ViewDetail: "oct:r",
    Create: "oct:c",
    Update: "oct:e",
    Active: "oct:ac",
    Inactive: "oct:in",
  },
} as const;
